import { FormLabel, TextField, Typography } from "@mui/material";

import { Box } from "@mui/material";

import { FormControl } from "@mui/material";
import { PlanFormValues } from "../FormTypes/PlanFormValues";
import { getIn, useFormikContext } from "formik";
import { Minus, Plus } from "react-feather";
import { useState } from "react";
export const RewardReasonFields = () => {
    const { values, errors, touched, setFieldValue } = useFormikContext<PlanFormValues>();
    const [addingReasonCategoryKey, setAddingReasonCategoryKey] = useState<number>(0);
    const [addingReasonCategory, setAddingReasonCategory] = useState<string | undefined>();

    return (
        <FormControl component="fieldset" fullWidth>
        <FormLabel component="legend">Reasons</FormLabel>
        {values?.controls?.payments?.reasonCategories?.map(
          (rc, index) => {
            return (
              <Box display="flex" alignItems="center">
                <Typography mt={index === 0 ? 2 : 1} mb={1}>
                  {rc}
                </Typography>

                <Minus
                  style={{ marginLeft: "auto" }}
                  onClick={() => {
                    setFieldValue(
                      "controls.payments.reasonCategories",
                      values?.controls?.payments?.reasonCategories?.filter(
                        (_, i) => i !== index
                      )
                    );
                  }}
                />
              </Box>
            );
          }
        )}

        <Box display="flex" alignItems="center" marginTop={1} gap={1}>
          <TextField
            key={addingReasonCategoryKey}
            value={addingReasonCategory}
            onChange={(e) => setAddingReasonCategory(e.target.value)}
            name="controls.payments.reasonCategories"
            fullWidth
            size="small"
            error={
              getIn(touched, "controls.payments.reasonCategories") &&
              Boolean(getIn(errors, "controls.payments.reasonCategories"))
            }
          />
          <Plus
            onClick={() => {
              if (!addingReasonCategory) return;

              let categories =
                values?.controls?.payments?.reasonCategories ?? [];
              categories.push(addingReasonCategory);

            setFieldValue(
                "controls.payments.reasonCategories",
                categories
              );
              setAddingReasonCategory(undefined);
              setAddingReasonCategoryKey(addingReasonCategoryKey + 1);
            }}
          />
        </Box>
        {getIn(touched, "controls.payments.reasonCategories") &&
          getIn(errors, "controls.payments.reasonCategories") && (
            <Typography color="error">
              {getIn(errors, "controls.payments.reasonCategories")}
            </Typography>
          )}
      </FormControl>
    )
}